var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_809_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12964 7.64855C9.12964 5.57476 10.8046 3.82001 12.9582 3.82001H35.9294C38.0032 3.82001 39.758 5.57476 39.758 7.64855V42.7435C39.758 43.8602 38.8806 44.6578 37.764 44.6578C37.3651 44.6578 36.9663 44.578 36.6473 44.3388L24.4438 35.7245L12.1606 44.3388C11.8415 44.578 11.4427 44.6578 11.0439 44.6578C9.92725 44.6578 9.12964 43.8602 9.12964 42.7435V7.64855Z",
    fill: "#F0635A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12964 8.28664C9.12964 5.8938 11.1237 3.82001 13.5963 3.82001H35.2914C37.6842 3.82001 39.758 5.8938 39.758 8.28664V42.584C39.758 43.7804 38.8008 44.6578 37.6044 44.6578C37.2056 44.6578 36.8068 44.578 36.408 44.3388L24.4438 35.8841L12.3999 44.3388C12.001 44.578 11.6022 44.6578 11.2034 44.6578C10.007 44.6578 9.12964 43.7804 9.12964 42.584V8.28664ZM13.5963 5.09619C11.7618 5.09619 10.4058 6.53189 10.4058 8.28664V42.584C10.4058 43.0626 10.7249 43.3816 11.2034 43.3816C11.363 43.3816 11.5225 43.3816 11.682 43.3019L24.045 34.6079C24.2843 34.4484 24.5236 34.4484 24.7629 34.6079L37.1259 43.3019C37.2854 43.3816 37.4449 43.3816 37.6044 43.3816C38.083 43.3816 38.4818 43.0626 38.4818 42.584V8.28664C38.4818 6.53189 37.0461 5.09619 35.2914 5.09619H13.5963Z",
    fill: "#44525C",
    stroke: "#44525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2839 12.5691C32.2839 11.9238 32.807 11.4007 33.4523 11.4007H34.5942C35.2395 11.4007 35.7626 11.9238 35.7626 12.5691V35.4939C35.7626 36.3965 34.6329 36.8038 34.057 36.1088V36.1088C32.911 34.7258 32.2839 32.9862 32.2839 31.1901V12.5691Z",
    fill: "white",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_809_10",
    x: 9.12964,
    y: 3.82001,
    width: 30.6283,
    height: 40.8378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.17877,
    dy: 5.84198
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_809_10"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.27c62e2f16a8a4b107e5166967b43f9a.svg";
export { ForwardRef as ReactComponent };